<template>
  <BilletReportFilter @export="exportReport" />
</template>
<script>
import BilletReportFilter from './components/BilletReportFilter.vue';

import reportsApi from '../../../../services/reports.api';
import notify from '../../../../utils/notify';
import functions from '../../../../utils/functions';

export default {
  name: 'BilletReport',

  components: {
    BilletReportFilter,
  },
  methods: {
    async exportReport(filters) {
      try {
        this.$vs.loading();
        const buffer = await reportsApi.exportBilletReport(filters);
        const now = functions.formataDataMomentJS(
          new Date().toISOString(),
          'DD-MM-YYYY HH:mm',
        );

        const fileName = `Relatório Boletos - ${now}.xlsx`;
        await functions.downloadFromBuffer(window, buffer, fileName);
      } catch (error) {
        notify.notifyFail(this.$vs, 'Falha ao gerar o relatório de boletos');
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
